import { createElement } from "react";
import { createRoot } from "react-dom/client";

import RequestForm from "./components/RequestForm";
import LoadingExperience from "./components/LoadingExperience";
import DemoShowcase from "./components/demo/DemoShowcase";
import { initScrollReveal } from "./scrollReveal";

const REGISTRY = { RequestForm, LoadingExperience, DemoShowcase };

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-react-component]").forEach((node) => {
    const Component = REGISTRY[node.dataset.reactComponent];
    if (!Component) return;
    const props = node.dataset.props ? JSON.parse(node.dataset.props) : {};
    createRoot(node).render(createElement(Component, props));
  });

  initScrollReveal();
});
